import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["helloassoFields", "sumupFields"]

  toggle() {
    const selectedProvider = this.element.querySelector('input[name="team[payment_provider]"]:checked')?.value || 'helloasso'

    if (selectedProvider === 'sumup') {
      this.helloassoFieldsTarget.style.display = 'none'
      this.sumupFieldsTarget.style.display = 'block'
    } else {
      this.helloassoFieldsTarget.style.display = 'block'
      this.sumupFieldsTarget.style.display = 'none'
    }
  }
}
